var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"hide-overlay":false,"persistent":"","max-width":"1000px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.show)?_c('BusinessTTKContent',{attrs:{"customer":{}},on:{"close":function($event){return _vm.$emit('close', true)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }